import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { MessagesSearch, MessagesTable, MessagesTableComponent, PrivateLayout } from '../components';
import { AppRootState, getUnreadMessageCount, navigateToComposeMessage } from '../redux';
import { FeatureGuard } from '../components/multi-tenant/FeatureGuard';
import { AnyType } from '../interfaces';

export const MessagesView = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { hash } = useLocation();
  const [searchText, setSearchText] = useState<string>('');
  const [isComposing, setIsComposing] = useState<boolean>(hash.includes('compose'));
  const messagesTableRef = useRef<MessagesTableComponent>(null);
  const secureMessageEnabled = useSelector(
    (state: AppRootState) =>
      (((state.app?.entities?.features as AnyType) ?? {})['secure-message.manage'] as AnyType)?.data?.enabled
  );

  const renderSubtoolbarChildren = useCallback(
    () => (
      <div className='d-flex align-items-center'>
        <div className='me-3'>
          <MessagesSearch onSearchChange={setSearchText} />
        </div>

        <Button
          className='text-nowrap compose-btn'
          variant='secondary-new'
          onClick={() => dispatch(navigateToComposeMessage())}>
          Compose Message
        </Button>
      </div>
    ),
    []
  );

  useEffect(() => {
    if (secureMessageEnabled) {
      dispatch(getUnreadMessageCount());
    }
  }, [dispatch]);

  return (
    <FeatureGuard contentKey='secure-message.manage'>
      <PrivateLayout
        pageTitle={'messages'}
        pageIcon={<i className='fa-light fa-envelope'></i>}
        subtoolbarChildren={renderSubtoolbarChildren()}
        disableViewContainer={false}>
        <MessagesTable ref={messagesTableRef} searchText={searchText} />
      </PrivateLayout>
    </FeatureGuard>
  );
};
